module.exports = __webpack_public_path__ + "assets/c1d5d15e36b491ba0784d622d06cf3b5.jpg";